// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2mJIv","inputDescription":"styles_inputDescription__kyOJA"};